<template>
  <!--借款合同-->
  <div class="borrow">
    <form>
      <h1 class="f-weight__500 text-center font-small title">借款协议</h1>

      <div class="cel cel-right">
        <div class="cel-content"><input class="width-mini" type="text" name="contractNo" v-model="form.contractNo"/></div>
        <div class="cel-content f-weight__600 font-small">编号：</div>
      </div>

      <div class="all-indent">
        <div class="cel">
          <div class="cel-content">甲方（借款人）：</div>
          <div class="cel-content__full"> <input type="text" class="width-full" name="fpName" v-model="form.fpName" /> </div>
        </div>
        <div class="cel">
          <div class="cel-content">住所：</div>
          <div class="cel-content__full"> <input type="text" class="width-full"  name="fpAddress" v-model="form.fpAddress" /> </div>
        </div>
        <div class="cel">
          <div class="cel-content">乙方（出借人）：</div>
          <div class="cel-content__full"> <input type="text" class="width-full"  name="spName" v-model="form.spName" /> </div>
        </div>
        <div class="cel">
          <div class="cel-content">住所：</div>
          <div class="cel-content__full"> <input type="text" class="width-full"  name="spAddress" v-model="form.spAddress" /> </div>
        </div>
      </div>

      <p>
        甲方因扩大经营，向出借方借款。经双方友好协商，特订立本合同，以昭信守。<br/>
        第一条 借款用途<br/>
        本合同所借款项用于<input type="text" class="width-medium" name="moneyUse" v-model="form.moneyUse"/>。<br/>
        第二条 借款金额及账户信息<br/>
        借款金额为：人民币<input type="text" class="width-medium" name="money" v-model="form.money"/>元（大写 <input type="text" class="width-medium" name="moneyZh" v-model="form.moneyZh"/>元整），实际借款额以转账金额为准。（账户信息如下：）
        <table class="table-systemp">
          <tbody>
          <tr>
            <td>户名</td>
            <td><input type="text" class="width-medium text-left" name="bankEntity" v-model="form.bankEntity"/></td>
          </tr>
          <tr>
            <td>银行账号</td>
            <td><input type="text" class="width-medium text-left" name="bankNo" v-model="form.bankNo"/></td>
          </tr>
          <tr>
            <td>开户银行</td>
            <td><input type="text" class="width-medium text-left" name="bankName" v-model="form.bankName"/></td>
          </tr>
          </tbody>
        </table>
        第三条 借款期限<br/>
        借款日期为<input type="text" name="borrowStart" v-model="form.borrowStart" >起至<input type="text" name="borrowEnd" v-model="form.borrowEnd">。<br/>
        第四条 借款偿还及利息支付<br/>
        (一)借款人按本合同规定到期一次性偿还全部本金。<br/>
        (二)本合同为无利息借款。
        <table class="table-systemp">
          <tbody>
          <tr>
            <td>户名</td>
            <td><input type="text" class="width-medium text-left" name="bankEntityB" v-model="form.bankEntityB"/></td>
          </tr>
          <tr>
            <td>银行账号</td>
            <td><input type="text" class="width-medium text-left" name="bankNoB" v-model="form.bankNoB"/></td>
          </tr>
          <tr>
            <td>开户银行</td>
            <td><input type="text" class="width-medium text-left" name="bankNameB" v-model="form.bankNameB"/></td>
          </tr>
          </tbody>
        </table>
        第五条 借贷双方权利义务：<br/>
        1、 借款方必须按照借款合同规定的用途使用借款，不得挪作他用，不得用借款进行违法活动。<br/>
        2、借款方应当按照合同约定期限按时还款。<br/>
        (二)出借方义务<br/>
        1、出借方应当按期足额将款项支付到借款人帐户。<br/>
        2、出借方应当对借款人相关的债务、财务、经营及各类商业信息保密。<br/>
        第六条 违约责任：<br/>
        1、如到期未还款，则应从还款到期之日起次日开始支付每月2%的利息，直至还清之日为止。<br/>
        2、本合同正式签订后，任何一方不履行或不完全履行本协议约定条款的，即构成违约。违约方应当负责赔偿其违约行为给守约方造成的一切经济损失。<br/>
        3、任何一方违约时，守约方有权要求违约方继续履行本协议<br/>
        第七条 协议的变更或解除：<br/>
        1、 借款人需要延长借款期限的，应在借款到期日前三日内向出借人提出书面申请，征得其同意。<br/>
        2、借款方使用借款造成损失浪费或利用借款合同进行违法活动的，贷款方应追回贷款本息，有关单位对直接责任人应追究行政和经济责任。情节严重的，由司法机关追究刑事责任。<br/>
        3、 由于行政主管部门决定关、停、并、转或者由于不可抗力的意外事故致使合同无法履行时，公司应进行清算。借款人可以向出借方申请，变更或解除合同，并免除承担违约责任。<br/>
        4、 本合同的变更，必须经双方共同协商，并订立书面变更协议。<br/>
        第八条 解决合同纠纷的方式：<br/>
        执行本合同发生争议，由当事人双方协商解决。协商不成，任何一方有权向公司注册地所在人民法院提起诉讼。<br/>
        第九条 其他<br/>
        本合同正本一式两份，双方各执一份，两份具有同等法律效力。<br/>
      </p>
      <p><b>（以下为签署页，无正文）</b></p>

      <div class="cel"> <div class="cel-content">借款人(盖章)：</div> </div>
      <div class="cel">
        <div class="cel-content">电话：</div>
        <div class="cel-content__full"><input type="text" class="width-full" name="fpMobile" v-model="form.fpMobile"/></div>
      </div>
      <div class="cel">
        <div class="cel-content">日期：</div>
        <div class="cel-content__full"><input  type="text" class="width-full" name="signDateA"  v-model="form.signDateA"  /></div>
      </div>
      <div class="cel">
        <div class="cel-content">签订地点：</div>
        <div class="cel-content__full"><input type="text" class="width-full" name="signAddressA" v-model="form.signAddressA"/></div>
      </div>
      <div style="margin-bottom: 100px">
        <div class="cel"> <div class="cel-content">出借人(盖章)：</div> </div>
        <div class="cel">
          <div class="cel-content">电话：</div>
          <div class="cel-content__full"><input type="text" class="width-full" name="spMobile" v-model="form.spMobile" /></div>
        </div>
        <div class="cel">
          <div class="cel-content">日期：</div>
          <div class="cel-content__full"><input type="text" class="width-full" name="signDateB" v-model="form.signDateB"  /></div>
        </div>
        <div class="cel">
          <div class="cel-content">签订地点：</div>
          <div class="cel-content__full"><input type="text" class="width-full"  name="signAddressB" v-model="form.signAddressB" /></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: "borrow",
    data() {
      return {
        form: {
          contractNo: '',
          fpName: '',
          fpAddress: '',
          spName: '',
          spAddress: '',
          moneyUse: '',
          money: '',
          moneyZh: '',
          bankEntity: '',
          bankNo: '',
          bankName: '',
          borrowStart: '',
          borrowEnd: '',
          bankEntityB: '',
          bankNoB: '',
          bankNameB: '',
          fpMobile: '',
          signDateA: moment(new Date()).format('YYYY年MM月DD日'),
          signAddressA: '',
          spMobile: '',
          signDateB: moment(new Date()).format('YYYY年MM月DD日'),
          signAddressB: ''
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .borrow {
    font-size: 16px;
    color: #666666;
    font-family: 微软雅黑 !important;
    margin-bottom: 1em;
  }

  @import "../../assets/style/sysTpl";
</style>



// WEBPACK FOOTER //
// components/sys-contract/borrow.vue